import { faqPagesBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateFaqPage = {
  name: "updateFaqPage" as const,
  input: z.object({
    _id: zExt.objectId(),
    title: z.string().optional(),
    description: z.string().optional(),
    collections: z.array(zExt.objectId()).optional(),
    published: z.boolean().optional(),
  }),
  output: z.union([
    z.object({ success: z.literal(true), data: faqPagesBodySchema }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
